import axios from "axios";

let requestLanguage;

axios.interceptors.request.use((config) => {
    if (requestLanguage !== undefined) {
        if (config.params instanceof URLSearchParams) {
            config.params = new URLSearchParams(config.params);
            config.params.set("lang", requestLanguage);
        } else {
            config.params = { ...config.params, lang: requestLanguage };
        }
    }

    return config;
});

export function setRequestLanguage(language) {
    requestLanguage = language;
}
